<template>
    <div class="error-container">
      <img src="../images/error.png" alt="">
      <div>
        <div class="error-code">
          <span>{{name}}</span>
          <span>{{argum}}</span>
        </div>
          <ul class="help-main">
            <li class="helpChil">{{help}}</li>
          </ul>   
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name:'error',
    data(){
        return{
            name:'code1001',
            argum:'参数非法',
            help:'如有帮助请联系仁能达',

        }
    }
  }
  </script>
  
  <style scoped>
  .error-container {
    height: 100vh;
    width: 100%;
    background-color:#fff;
    text-align: center;
  }
  
  img {
    width: 200px;
    height: auto;
    margin-right: 10px;
    margin-bottom: -30px;
  }

  ul{
    height: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  li{
    margin-top: 10px;
  }
  
  .error-code{
    margin-top: -10px;
  }

  .error-code span{
    margin-bottom: 0;
  }

  span {
    display: block;
    margin-bottom: 10px;
  }
  .help-main{
    margin-top: 50px;
  }

  .helpChil{
    font-size: 20px;
    color: #4b4949;
    font-weight: 600;
  }
  
  h3 {
    color: #716653;
    font-size: 22px;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  </style>